// ----------------------------------------------------------------------

export default function Tab(theme) {
  return {
    MuiTab: {
      styleOverrides: {
        root: {
          color: theme.palette.text.primary,
          minHeight: "unset !important",
          fontSize: "16px !important",
          fontWeight: theme.typography.fontWeightMedium,
          borderTopLeftRadius: theme.shape.borderRadius,
          borderTopRightRadius: theme.shape.borderRadius,
          "&.Mui-selected": {
            color: theme.palette.primary.main,
          },
          "&:not(:last-of-type)": {
            marginRight: 0,
          },

          minWidth: 30,
          padding: 6,

          // "&:not(:last-of-type)": {
          //   marginRight: theme.spacing(5),
          // },
          // "@media (min-width: 600px)": {
          //   minWidth: 48,
          // },
        },

        labelIcon: {
          minHeight: 48,
          flexDirection: "row",
          "& > *:first-of-type": {
            marginBottom: 0,
            marginRight: theme.spacing(1),
          },
        },
        wrapper: {
          flexDirection: "row",
          whiteSpace: "nowrap",
        },
        textColorInherit: {
          opacity: 1,
          color: theme.palette.text.secondary,
        },
      },
    },
    MuiTabPanel: {
      styleOverrides: {
        root: {
          padding: 0,
        },
      },
    },
    MuiButtonBase: {
      styleOverrides: {
        root: {
          fontSize: "14px !important",
        },
      },
    },
    MuiTabScrollButton: {
      styleOverrides: {
        root: {
          width: 20,
          borderRadius: "50%",
        },
      },
    },
  };
}
